/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Sidebar_Delete_Toast_Bulk_Success_TitleInputs */

const es_sidebar_delete_toast_bulk_success_title = /** @type {(inputs: Sidebar_Delete_Toast_Bulk_Success_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} chats eliminados`)
};

const en_sidebar_delete_toast_bulk_success_title = /** @type {(inputs: Sidebar_Delete_Toast_Bulk_Success_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} chats deleted`)
};

/**
* | output |
* | --- |
* | "{count} chats deleted" |
*
* @param {Sidebar_Delete_Toast_Bulk_Success_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const sidebar_delete_toast_bulk_success_title = /** @type {((inputs: Sidebar_Delete_Toast_Bulk_Success_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Delete_Toast_Bulk_Success_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_sidebar_delete_toast_bulk_success_title(inputs)
	return en_sidebar_delete_toast_bulk_success_title(inputs)
});
export { sidebar_delete_toast_bulk_success_title as "sidebar.delete_toast.bulk_success_title" }